/*
 * @Description: 开户流程模块
 * @Author: Harry
 * @Date: 2020-12-28 13:48:01
 * @LastEditTime: 2021-04-06 12:52:43
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  // H5开户入口
  {
    path: "/account-index",
    name: "AccountIndex",
    component: () => import("@/views/create-account/Index.vue"),
    meta: {
      title: i18n.t("register.nav_title")
    }
  },
  //选择开户方式页面
  {
    path: "/mode-select",
    name: "ModeSelect",
    component: () => import("@/views/create-account/ModeSelect.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("open_account.mode_select.nav_title"),
      deepth: 0
    }
  },
  // 个人开户前置页
  {
    path: "/new-personal-opening",
    name: "NewPersonalOpening",
    component: () => import("@/views/create-account/NewPersonalOpening.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("newaccount.new_title"),
      deepth: 0
    }
  },
  // 港美股前置页
  {
    path: "/stocks-broker",
    name: "stocksBroker",
    component: () => import("@/views/create-account/stocksBroker.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("selectopening.market_hk"),
      deepth: 0
    }
  },
  // 空白前置页
  {
    path: "/stocks-broker-futures",
    name: "stocksBrokerfutures",
    component: () => import("@/views/create-account/stocksBrokerfutures.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("selectopening.market_glo"),
      deepth: 0
    }
  },


  // 选择开户类型
  {
    path: "/account-opening",
    name: "AccountOpening",
    component: () => import("@/views/create-account/AccountOpening.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("selectopening.navtitle"),
      deepth: 0
    }
  },
  {
    path: "/open-reference",
    name: "OpenReference",
    component: () => import("@/views/create-account/OpenReference.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("openReference.nav_title"),
      deepth: 0
    }
  },
  // 机构开户
  {
    path: "/institutional-open",
    name: "InstitutionalOpen",
    component: () => import("@/views/create-account/InstitutionalOpen.vue"),
    meta: {
      showHeader: true,
      title: "机构开户",
      keepAlive: true,
      deepth: 0
    }
  },
  {
    path: "/mservice-opening",
    name: "MServiceOpening",
    component: () => import("@/views/create-account/MServiceOpening.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.service_opening.nav_title")
    }
  },
  {
    path: "/m-result",
    name: "MResult",
    component: () => import("@/views/create-account/MResult.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: "高盈证券"
    }
  },
  //上传身份证照片页面
  {
    path: "/idcard-upload",
    name: "IDCardUpload",
    component: () => import("@/views/create-account/IDCardUpload.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t('open_account.idcard_verify.nav_title1')
    }
  },
  //填写身份证信息页面
  {
    path: "/idcard-verify",
    name: "IDCardVerify",
    component: () => import("@/views/create-account/IDCardVerify.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t('open_account.idcard_verify.nav_title1')
    }
  },
  //视频拍摄页面（模仿腾讯人脸核身页面，获取人脸视频供照片比对接口使用）
  {
    path: "/face-record",
    name: "FaceRecord",
    component: () => import("@/views/create-account/FaceRecord.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("face_recognition.nav_title")
    }
  },
  //腾讯人脸核身的结果返回页
  {
    path: "/face-result",
    name: "FaceResult",
    component: () => import("@/views/create-account/FaceResult.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("face_recognition.nav_title")
    }
  },
  //脸核身的结果返回失败页
  {
    path: "/face-fail",
    name: "FaceFail",
    component: () => import("@/views/create-account/FaceFail.vue"),
    meta: {
      // showHeader: true,
      keepAlive: true,
      title: i18n.t("face_recognition.nav_title")
    }
  },
  //脸核身的结果返回成功页
  {
    path: "/face-success",
    name: "FaceSuccess",
    component: () => import("@/views/create-account/FaceSuccess.vue"),
    meta: {
      // showHeader: true,
      keepAlive: true,
      title: i18n.t("face_recognition.nav_title")
    }
  },
  //个人信息补充页面
  {
    path: "/personal-info-supply",
    name: "PersonalInfoSupply",
    component: () => import("@/views/create-account/PersonalInfoSupply.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.personal_info_supply.nav_title")
    }
  },
  //绑定邮箱页面
  {
    path: "/email-bind",
    name: "EmailBind",
    component: () => import("@/views/EmailBind.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.email_bind.nav_title")
    }
  },
  //客户申明页面
  {
    path: "/customer-state",
    name: "CustomerState",
    component: () => import("@/views/create-account/CustomerState.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.customer_state.nav_title")
    }
  },
  //住址证明页面
  {
    path: "/address-proof",
    name: "AddressProof",
    component: () => import("@/views/create-account/AddressProof.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.address_proof.nav_title")
    }
  },
  //税务目的地页面
  {
    path: "/tax-resident-info",
    name: "TaxResidentInfo",
    redirect: "/tax-resident-info/page-one"
  },
  {
    path: "/tax-resident-info/page-one",
    name: "TaxResidentInfoPageOne",
    component: () =>
      import("@/views/create-account/tax-resident-info/PageOne.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.tax_resident_info.page_one.nav_title")
    }
  },
  {
    path: "/tax-resident-info/page-two",
    name: "TaxResidentInfoPageTwo",
    component: () =>
      import("@/views/create-account/tax-resident-info/PageTwo.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.tax_resident_info.page_two.nav_title")
    }
  },
  //w8ben资料填写
  {
    path: "/w8ben",
    name: "W8BEN",
    component: () => import("@/views/create-account/W8BEN.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.w_8ben.page_title")
    }
  },
  //用户资料
  {
    path: "/account-info",
    name: "AccountInfo",
    component: () => import("@/views/create-account/AccountInfo.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.account_info.nav_title")
    }
  },
  //适当性调查
  {
    path: "/survey",
    name: "Survey",
    redirect: "/survey/page-one",
    component: () => import("@/views/create-account/survey/index.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.survey.nav_title")
    },
    children: [
      {
        path: "page-one",
        name: "SurveyPageOne",
        component: () => import("@/views/create-account/survey/PageOne.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("open_account.survey.nav_title")
        }
      },
      {
        path: "page-two",
        name: "SurveyPageTwo",
        component: () => import("@/views/create-account/survey/PageTwo.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("open_account.survey.nav_title")
        }
      },
      {
        path: "page-three",
        name: "SurveyPageThree",
        component: () => import("@/views/create-account/survey/PageThree.vue"),
        meta: {
          showHeader: true,
          keepAlive: true,
          title: i18n.t("open_account.survey.nav_title")
        }
      }
    ]
  },

  //风险批露
  {
    path: "/risk-disclosure",
    name: "RiskDisclosure",
    component: () => import("@/views/create-account/RiskDisclosure.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.risk_disclosure.nav_title")
    }
  },
  // 客户款项常设授权
  {
    path: "/customer_payments",
    name: "Customer_payments",
    component: () => import("@/views/create-account/customer_payments.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.customer_payment.nav_title")
    }
  },




  // 客户款项常设授权
  {
    path: "/customer_payments_two",
    name: "Customer_payments_two",
    component: () => import("@/views/create-account/customer_payments_two.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.customer_payment_two.nav_title")
    }
  },
  // 客户款项常设授权
  {
    path: "/customer_payments_three",
    name: "Customer_payments_three",
    component: () => import("@/views/create-account/customer_payments_three.vue"),
    meta: {
      showHeader: true,
      keepAlive: false,
      title: i18n.t("open_account.customer_payment_three.nav_title")
    }
  },

  //风险评估首页
  {
    path: "/risk-assessment",
    name: "RiskAssessment",
    component: () => import("@/views/risk-assessment/index.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("assessment.entry.pageTitle")
    }
  },
  //风险评估问题
  {
    path: "/risk-questionnaire",
    name: "RiskQuestionnaire",
    component: () => import("@/views/risk-assessment/RiskQuestionnaire.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("assessment.question.pageTitle")
    }
  },
  //风险评估结果
  {
    path: "/assessment-result",
    name: "AssessmentResult",
    component: () => import("@/views/risk-assessment/AssessmentResult.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("assessment.result.pageTitle")
    }
  },
  //证券及/或期货客户协议
  {
    path: "/customer-agreement",
    name: "CustomerAgreement",
    component: () => import("@/views/create-account/CustomerAgreement.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.customer_agreement.page_title")
    }
  },
  //证券及/或期货客户协议
  {
    path: "/customer-agreement1",
    name: "CustomerAgreement1",
    component: () => import("@/views/create-account/CustomerAgreement1.vue"),
    meta: {
      showHeader: true,
      keepAlive: false,
      title: i18n.t("open_account.customer_agreement1.page_title")
    }
  },
  //个人资料(私隐)政策/ 私隐政策声明
  {
    path: "/personal-data",
    name: "PersonalData",
    component: () => import("@/views/create-account/PersonalData.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.personal_data.page_title")
    }
  },
  //衍生品基本知识课程
  {
    path: "/knowledge-courses",
    name: "KnowledgeCourses",
    component: () => import("@/views/create-account/KnowledgeCourses.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.knowledge_courses.page_title")
    }
  },
  //客户资料收集声明
  {
    path: "/collection-statement",
    name: "CollectionStatement",
    component: () => import("@/views/create-account/CollectionStatement.vue"),
    meta: {
      showHeader: true,
      keepAlive: false,
      title: i18n.t("open_account.collection_statement.page_title")
    }
  },

  //服务开通
  {
    path: "/service-opening",
    name: "ServiceOpening",
    component: () => import("@/views/create-account/ServiceOpening.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.service_opening.nav_title")
    }
  },
  //衍生品的认知
  {
    path: "/cognition-of-derivatives",
    name: "CognitionOfDerivatives",
    component: () =>
      import("@/views/create-account/CognitionOfDerivatives.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.survey.nav_title")
    }
  },
  {
    path: "/customer-confirm",
    name: "CustomerConfirm",
    component: () =>
      import("@/views/create-account/customer_confirm.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: "客户确认"
    }
  },
  //交易密码设置
  {
    path: "/trade-password-setting",
    name: "TradePasswordSetting",
    component: () => import("@/views/create-account/TradePasswordSetting.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.trade_password_setting.nav_title")
    }
  },
  //电子签署
  {
    path: "/electronic-sign",
    name: "ElectronicSign",
    component: () => import("@/views/create-account/ElectronicSign.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.electronic_sign.nav_title")
    }
  },
  //签字板
  {
    path: "/sign-write",
    name: "SignWrite",
    component: () => import("@/views/create-account/SignWrite.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.electronic_sign.nav_title")
    }
  },
  //开户结果页
  {
    path: "/account-result",
    name: "AccountResult",
    component: () => import("@/views/create-account/AccountResult.vue"),
    meta: {
      showHeader: true,
      keepAlive: false,
      title: i18n.t("register.nav_title")
    }
  },
  //开户失败原因
  {
    path: "/fail-reason",
    name: "FailReason",
    component: () => import("@/views/create-account/FailReason.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("fail_reason.nav_title")
    }
  },
  //资料需修改原因
  {
    path: "/fail-reason-data",
    name: "FailReasonData",
    component: () => import("@/views/create-account/FailReasonData.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("fail_reason.nav_title")
    }
  },
  // 加开 开户失败- 代办中转页面 资料需修改原因
  {
    path: "/fail-reason-data-new",
    name: "FailReasonData",
    component: () => import("@/views/create-account/FailReasonDataNew.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("fail_reason.nav_title")
    }
  },
  {
    path: "/modify-result",
    name: "ModifyResult",
    component: () => import("@/views/create-account/FailReason.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("fail_reason.nav_title"),
      keepAlive: true,
      backPath: "/"
    }
  },
  //手机号验证
  {
    path: "/phone-verify",
    name: "PhoneVerify",
    component: () => import("@/views/create-account/PhoneVerify.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("fail_reason.nav_title")
    }
  },
  {
    path: "/country-list",
    name: "TaxResidentInfoCountryList",
    component: () =>
      import("@/views/create-account/tax-resident-info/CountryList.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("open_account.country_list.nav_title")
    }
  },
  {
    path: "/all-country-list",
    name: "CountryList",
    component: () => import("@/views/create-account/CountryList.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("choose_nationality")
    }
  }
];
